module.exports = __webpack_public_path__ + "static/media/term-rename.9dc88a0a.png";